export default "CREATE INDEX `is_deleted_is_enabled_is_default_idx` ON `prompt` (`is_deleted`,`is_enabled`,`is_default`);"